import React          from 'react';
import egg            from '../../images/egg.png';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        backgroundImage:    `url(${ egg })`,
        display:            'flex',
        alignItems:         'center',
        justifyContent:     'center',
        float:              'left',
        position:           'fixed',
        cursor:             'grab',
        zIndex:             2,
    }
}));

type GhostProps = { 
  position:    number[];
  width:       number;
  height:      number;
  eggGhost:    boolean;
}

const Ghost: React.FC<GhostProps> = ({ position, width, height, eggGhost }) => {

  const classes = useStyles();

  return (
    <div
       className = { classes.root }
       style     = {{
        width:      width,
        height:     height,
        left:       eggGhost ? position[0] : -9999, 
        top:        eggGhost ? position[1] : -9999,
       }}
    />
   )
}

export default Ghost;


